__turbopack_context__.v({
  "button": "InsightViewerPage-module__KHjbNa__button",
  "buttonText": "InsightViewerPage-module__KHjbNa__buttonText",
  "shine": "InsightViewerPage-module__KHjbNa__shine",
});
